// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "./dist/chunks/" + {"249":"flatpickr","595":"star-rating"}[chunkId] + "." + {"249":"d09c1343","595":"26aaf6c2"}[chunkId] + ".css";
};